// Lists
const eventTypes = {
  doorTrigger: 'doorTrigger',
};

/**
* Model
*/
const event = {
  // Name
  name: 'event',

  // Utils
  types: eventTypes,
};

module.exports = event;



// WEBPACK FOOTER //
// ./models/cpm/event.js